/* unplugin-vue-components disabled */import script from "./Counter.vue?vue&type=script&setup=true&lang=js"
export * from "./Counter.vue?vue&type=script&setup=true&lang=js"

import "./Counter.vue?vue&type=style&index=0&id=fd7d9878&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd7d9878"]])

export default __exports__